import { call, get } from "vuex-pathify";
export default {
  name: "MlFaq",
  computed: {
    faq: get("faq")
  },
  created: function created() {
    this.carregar();
  },
  methods: {
    carregar: call("faq/carregar")
  }
};